import React, { useEffect, useContext, useState } from 'react'
import StoreContext from '../../providers/storesContext'
import { Link, useHistory } from 'react-router-dom'
import { ChevronLeftIcon } from '@heroicons/react/outline'
import { topBarStore } from '../../../lib/stores/TopBarStore'
import { caseDetailUrl, caseReleaseSuccessUrl, caseSuccessUrl } from '../../routing/paths'
import VerificationCode from '../../components/VerificationCode'
import Spinner from '../../../lib/components/Spinner'
import ServerError from '../../../lib/components/ServerError'
import Button from '../../components/Button'

const CaseSelfRelease = () => {
  const history = useHistory()
  const { caseDetailStore } = useContext(StoreContext)
  const [code, setCode] = useState(null)
  const [loadingCode, setLoadingCode] = useState(true)
  const [codeRetrieveError, setCodeRetrieveError] = useState(false)

  const { immobilizationCase } = caseDetailStore

  const loadCode = async () => {
    setLoadingCode(true)
    setCodeRetrieveError(false)

    try {
      const { data } = await caseDetailStore.getReleaseCode(immobilizationCase.id)

      setCode(data.code)
    } catch (e) {
      setCodeRetrieveError(true)
    }

    setLoadingCode(false)
  }

  useEffect(() => {
    if (!(immobilizationCase.isSelfRelease || immobilizationCase.isBootboxed)) {
      history.push(caseDetailUrl(immobilizationCase))
    }

    loadCode()

    topBarStore.setActionIcon(
      <Link to={caseSuccessUrl(immobilizationCase)}>
        <ChevronLeftIcon className="h-6 w-6" />
      </Link>
    )
    topBarStore.setTitle('Self Release')
  }, [])

  return (
    <div className="flex flex-1 flex-col justify-center">
      <div className="aspect-w-16 aspect-h-9">
        <iframe
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          src="https://www.youtube.com/embed/_VSD_iKWIkI"
          title="YouTube video player"
          frameBorder="0"
          allowFullScreen
          height="100%"
          width="100%"
        />
      </div>
      <h1 className="font-bold text-gray-800 text-center mb-4 mt-12">Verification code</h1>
      <div className="my-4">
        {code && !codeRetrieveError && (
          <VerificationCode code={code} handleRefreshCode={loadCode} loading={loadingCode} />
        )}
        {codeRetrieveError && (
          <ServerError
            message={
              <>
                We couldn't get a code.
                <br />
                <span onClick={loadCode} className="font-bold underline">
                  Please try again
                </span>
                .
              </>
            }
          />
        )}
        {loadingCode && !code && (
          <div className="flex justify-center">
            <Spinner color="text-primary-light" size={8} />
          </div>
        )}
      </div>
      <div>
        <h2 className="font-bold text-gray-800 text-center my-4">Steps to release</h2>
        <ul>
          <li className="text-gray-600">
            <span className="font-bold">01.</span> Use key to release
          </li>
          <li className="text-gray-600">
            <span className="font-bold">02.</span> Expand green boot arm and remove
          </li>
        </ul>
      </div>
      <Button as={Link} extraStyle="mt-14 mb-4" to={caseReleaseSuccessUrl(immobilizationCase)}>
        Done
      </Button>
    </div>
  )
}

export default CaseSelfRelease
